import React from 'react';
import Table from '../../../components/table/Table';
import {TableHeader} from '../../../components/header/TableHeader';
import {CardStyle} from '../../../components/card/taskCard.style';
import {
  CardHeader,
  CardBody,
  CardFooter,
} from '../../../components/card/taskCard';
import {TaskAction} from '../../../services/taskService';
import Config from '../../../Config';
import {TaskTableStyle} from '../styles/TaskTable.style';
import {taskFields} from 'src/constant/task.fields';
import {useNavigate} from 'react-router-dom';
import { routeLink } from 'src/constant';
const {defaultListLimit} = Config;

const renderTaskCard = ({row}) => {
  if (!row) return 'No Data Found';
  const action = TaskAction(row);
  return (
    <CardStyle>
      <CardHeader item={row} actions={[action]} />
      <CardBody item={row} />
      <CardFooter item={row} />
    </CardStyle>
  );
};

export const TaskTable = ({
  title,
  filter,
  addOnFilter,
  eventSourceId,
  reduxKey,
  ...props
}) => {
  const navigate = useNavigate();

  return (
    <Table
      reduxKey={reduxKey}
      renderHeader={() => <TableHeader title={title} />}
      onRowPress={({row}) => {
        navigate(`/patient/details/${row?.patientId?._id}/tcmEncounter`, {
          state: {
            patient: row.patientId,
            encounter: row.encounterId,
          },
        });
      }}
      noDataText="No task found"
      style={TaskTableStyle}
      sort={{isDateBounded: -1, onGoingTcmDueDate: 1, _id: 1}}
      api={`${routeLink.getTCMTask}`}
      eventSourceId={eventSourceId}
      filter={filter}
      addOnFilter={addOnFilter}
      perPage={defaultListLimit}
      fields={taskFields}
      columns={[{render: renderTaskCard}]}
      marginPagesDisplayed={4}
      {...props}
    />
  );
};
